<template>
  <div class="container-fluid">
    <nav class="navbar">
      <div class="mx-auto"><a class="navbar-brand">{{Order?.serialId}}</a></div>
    </nav>
    <div class="row Order" v-if="Order">
      <div class="col col-11 col-md-5 col-xl-3">
        <div class="input-group">
          <label>店家名稱：</label>
          <input type="text" class="form-control" v-model="Order.shopName" disabled>
        </div>
        <div class="input-group">
          <label>店家電話：</label>
          <input type="text" class="form-control" v-model="Order.shopPhone" disabled>
        </div>
        <div class="input-group">
          <label>店家回覆：</label>
          <input type="text" class="form-control" v-model="Order.shopReply" disabled>
        </div>
        <div class="input-group" v-if="!Order.discountPrice">
          <label>訂單價格：</label>
          <input type="text" class="form-control" v-model="Order.Price" disabled>
        </div>
        <div class="input-group" v-else>
          <label>訂單價格：</label>
          <input type="text" class="form-control" v-model="Order.discountPrice" disabled>
        </div>
        <div class="input-group">
          <label>訂單品項：</label>
          <input type="text" class="form-control" v-model="orderDetailCount" disabled>
        </div>
        <div class="input-group">
          <label>付款方式：</label>
          <input type="text" class="form-control" v-model="Order.payMethod" disabled>
        </div>
        <div class="input-group">
          <label>用餐方式：</label>
          <input type="text" class="form-control" v-model="Order.diningModel" disabled>
        </div>
        <div class="input-group">
          <label>下單時間：</label>
          <input type="text" class="form-control" v-model="Order.Time" disabled>
        </div>
        <div class="input-group">
          <label>出餐時間：</label>
          <input type="text" class="form-control" v-model="Order.mealDoneTime" disabled>
        </div>
        <div class="input-group" v-if="Order.diningModel != '內用'">
          <label>取餐時間：</label>
          <input type="text" class="form-control" v-model="Order.takeMealTime" disabled>
        </div>
        <div class="input-group" v-if="Order.tableNumber">
          <label>內用桌號：</label>
          <input type="text" class="form-control" v-model="Order.tableNumber" disabled>
        </div>
        <div class="input-group" v-if="Order.Address">
          <label>外送地址：</label>
          <input type="text" class="form-control" v-model="Order.Address" disabled>
        </div>
        <div class="input-group">
          <label>訂單備註：</label>
          <textarea class="form-control" rows="3" v-model="Order.Statement" disabled></textarea>
        </div>
        <div class="input-group" v-if="Order.Activity">
          <label>訂單活動：</label>
          <textarea class="form-control" rows="3" v-model="Order.Activity" disabled></textarea>
        </div>
        <div class="orderUserList" v-for="User in Order.Users" :key="User.id">
          <div class="userName" v-show="(Global.User?.id !== User.userId) && Global.isGuest == false">{{User.Name}} 訂這些</div>
          <table>
            <thead :class="{ otherUser: !(Global.User?.id == User.userId) }">
              <td>商品名稱</td><td>商品數量</td><td>商品價格</td>
            </thead>
            <tr v-for="index in User.Products" :key="index.id">
              <td>
                {{index.productName}}
                <span v-for="(productItem, index) in index.Items" :key="(productItem, index)">
                  <span> / </span>{{productItem.Name}}
                </span>
              </td>
              <td>{{index.productCount}}</td>
              <td>${{index.productPrice}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="row Button">
      <div class="col">
        <button class="btn btn-dark" @click="Orders()">返回上頁</button>
        <button class="btn btn-primary" v-show="Global.isGuest == false && this.$data.Order?.isUser == 1" @click="OrderAgain()">再點一次</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Global } from '@/Service/GlobalService'

import { getUserOrder, getUserOrderByGuest, getProductDetails } from '@/Service/APIService'

export default {
  name: "Order",
  data() {
    return {
      Global: Global,                 // 給上方 HTML 使用
      orderId: this.$route.params.id, // 訂單ID
      Order: null,                    // 訂單資訊
      orderDetailCount: 0,            // 訂單品項
    }
  },
  methods: {
    /* 初始化，取得訂單資料 */
    init: async function() {
      let response

      if (Global.isGuest == null || Global.isGuest == true) {
        response = await getUserOrderByGuest(this.$data.orderId)
      } else {
        response = await getUserOrder(this.$data.orderId)
      }
      
      this.$data.Order = response.data
      this.$data.Order.Users.forEach(User => {
        User.Products.forEach(e => { this.$data.orderDetailCount += e.productCount })
      })
    },
    OrderAgain: async function() {
      if (!Global.User?.id) return false
      const user = this.$data.Order.Users.find(user => user.userId === Global.User.id)
      const productInfo = user.Products.map(item => ({ productId: item.productId, Count: item.productCount, Items: item.Items }))
      const productIds = productInfo.map(product => product.productId)
      const response = await getProductDetails({ 'productIds': productIds })
      const products = response.data.data
      const finalProducts = productInfo.map(item => {
        const details = products.find(product => product.id === item.productId)
        const itemsTotalPrice = item.Items.reduce((sum, subItem) => sum + subItem.Price, 0)
        return { productId: item.productId, Count: item.Count, productCategoryId: details.productCategoryId, Price: details.Price + itemsTotalPrice, Name: details.Name, Image: details.Image, Items: Array.from(item.Items) }
      })
      localStorage.setItem('Cart.' + this.$data.Order.shopId, JSON.stringify(finalProducts))
      this.$router.push({ path: `/Shop/${this.$data.Order.shopId}` })
    },
    /* 前往十筆最新訂單頁面 */
    Orders: function() {
      this.$router.push({ name: `Orders` })
    },
    /* 前往本次訂單的店家頁面 */
    Shop: function(shopId) {
      this.$router.push({ path: `/Shop/${shopId}` })
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.container-fluid, .row, .col {
  margin: 0px;
  padding: 0px;
  justify-content: center;
  > .navbar {
    margin-bottom: 30px;
    padding: 0px 20px;
    height: 8vh;
    background-color: #5599FF;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 900;
    > .mx-auto {
      > .navbar-brand {
        margin: 0px;
        color: #FFFFFF;
      }
    }
  }
  > .input-group {
    margin-bottom: 10px;
    > label {
      text-align: right;
      width: 100px;
      line-height: 38px;
      margin-right: 10px;
      font-weight: bold;
    }
    > input[type=text] {
      width: 50% !important;
    }
  }
  > .orderUserList {
    margin-top: 20px;
    > .userName {
      padding-left: 5px;
      font-weight: bold;
      text-align: left;
    }
    > table {
      margin: 5px auto 25px auto;
      width: 100%;
      text-align: center;
      font-weight: 900;
      font-size: 18px;
      > tr {
        height: 35px;
        > td {
          border: 2px solid #000000;
        }
      }
      > thead {
        background-color: #87CEFA;
        color: #FFFFFF;
        > td {
          border: 2px solid #000000;
        }
      }
      > thead.otherUser {
        background-color: #00E3E3;
      }
    }
  }
  > .Button {
    padding-bottom: 20px;
    > .col {
      text-align: center;
      button:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
}
</style>